import InfoIcon from "@mui/icons-material/Info";
import { NativeSelect, TextField } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import AdditionalContactDetails from "../../types/AdditionalContactDetails";
import { FlagableTextField } from "../purchaseOrderRelease/FlagableTextField";
import { isValidEmail, isValidPhone } from "../../helper/ContactValidationUtilities";

interface Iprops {
  showContactDetails: boolean;
  defaultContactName: string;
  defaultEmailAddress: string;
  defaultPhoneNumber: string;
  defaultFacilityType: string;
  additionalContactsList: AdditionalContactDetails[];
  updateContactList(additionaContactDet: AdditionalContactDetails[]): void;
  operationType: string;
}

export interface IState {
  tableHeaders: string[];
  rows: AdditionalContactDetails[];
  showContactDetails: boolean;
  defaultValuesLoaded: boolean;
  previousFacilityType: string | null;
  thirdPartyContactXId: string;
  operationType: string;
}

export default class AdditionalContacts extends React.Component<
  Iprops,
  IState
> {
  constructor(props: Iprops) {
    super(props);
    this.state = {
      tableHeaders: [
        "",
        "Contact ID",
        "Contact Name",
        "Contact Type",
        "Email Address",
        "Phone Number",
        "",
      ],
      rows: this.props.additionalContactsList
        ? this.props.additionalContactsList
        : [],
      showContactDetails: this.props.additionalContactsList ? true : false,
      defaultValuesLoaded: false,
      thirdPartyContactXId: "",
      previousFacilityType: null,
      operationType: this.props.operationType ? this.props.operationType : "",
    };
  }

  handleChange(contactXid: string, event: any) {
    var rowsArray = this.state.rows;
    var newRow = rowsArray.map((row) => {
      if (row.contactXid === contactXid) {
        if ("ContactName" === event.target.name) {
          row.contactName = event.target.value;
        }
        if ("EmailAddress" === event.target.name) {
          row.emailAddress = event.target.value;
        }
        if ("PhoneNumber" === event.target.name) {
          row.phone1 = event.target.value.replace(/[^0-9]/g, "");
        }
        if ("ContactType" === event.target.name) {
          row.jobTitle = event.target.value;
        }
        if ("ActiveStatus" === event.target.name) {
          row.active = event.target.checked;
        }
        row.operation = "IU";
      }
      return row;
    });
    this.setState({ rows: newRow }, () => {
      this.props.updateContactList([...newRow]);
    });
  }

  handleAddRow = () => {
    try {
      const date = Date.now();
      let contactGid: string = "";
      let contactXid: string = "";
      let jobTitle: string = "";

      if(this.props.operationType === "RELEASE_SUMMARY") {
        contactGid = "RE" + date;
        contactXid = "RE" + date;
        jobTitle = "RELEASE_SUMMARY";
      } else if(this.props.operationType === "TENDER") {
        contactGid = "TE" + date;
        contactXid = "TE" + date;
        jobTitle = "TENDER";
      } else if(this.props.operationType === "WAREHOUSE") {
        contactGid = "WH" + date;
        contactXid = "WH" + date;
        jobTitle = "WAREHOUSE";
      } else if(this.props.operationType === "VENDOR_RESPONSIBLE") {
        contactGid = "VR" + date;
        contactXid = "VR" + date;
        jobTitle = "VENDOR_RESPONSIBLE";
      }
      const tableColProps = new AdditionalContactDetails(
        contactGid,
        contactXid,
        "",
        jobTitle,
        "",
        "",
        "IU",
        true,
        true
      );
      

      if (this.state.rows.length === 0) {
        this.setState({ rows: [tableColProps], showContactDetails: true }, () =>
          this.props.updateContactList([...this.state.rows])
        );
      } else {
        const rowsArray = [...this.state.rows, tableColProps];
        this.setState({ rows: rowsArray }, () =>
          this.props.updateContactList([...rowsArray])
        );
      }
    } catch (error) {
      console.log("Error in React Table handle Add Row : " + error);
    }
  };

  handleRemoveSpecificRow = (contactXid: string) => () => {
    const newRow = this.state.rows.filter((row: AdditionalContactDetails) => {
      if (row.contactXid !== contactXid) {
        return row;
      }
    });
    this.setState({ rows: newRow }, () => {
      this.props.updateContactList([...this.state.rows]);
    });
  };

  render() {
    if (!this.state.thirdPartyContactXId){
      this.state.rows.filter((row: AdditionalContactDetails) => {
        if (row.jobTitle === "VENDOR_RESPONSIBLE") {
          this.setState({ thirdPartyContactXId: row.contactXid });
        }
      });
    }
    if ((this.props.showContactDetails && !this.state.defaultValuesLoaded)
      || (this.state.previousFacilityType && this.state.previousFacilityType !== this.props.defaultFacilityType)
      || (this.props.defaultFacilityType === "VENDOR_RESPONSIBLE" && this.state.previousFacilityType &&
        this.state.previousFacilityType !== this.props.defaultFacilityType)) {
      var types: any = [];
      this.state.rows.forEach((contact: AdditionalContactDetails) => {
        types.push(contact.jobTitle);
      });

      if (!types.includes("RELEASE_SUMMARY") && this.props.operationType === "RELEASE_SUMMARY") {
        this.state.rows.push(
          new AdditionalContactDetails(
            "",
            "RE" + Date.now(),
            this.props.defaultContactName,
            "RELEASE_SUMMARY",
            this.props.defaultEmailAddress,
            this.props.defaultPhoneNumber,
            "IU",
            true,
            true
          )
        );
      }
      if (!types.includes("TENDER") && this.props.operationType === "TENDER") {
        this.state.rows.push(
          new AdditionalContactDetails(
            "",
            "TE" + Date.now(),
            this.props.defaultContactName,
            "TENDER",
            this.props.defaultEmailAddress,
            this.props.defaultPhoneNumber,
            "IU",
            true,
            true
          )
        );
      }
      if (!types.includes("WAREHOUSE") && this.props.operationType === "WAREHOUSE") {
        this.state.rows.push(
          new AdditionalContactDetails(
            "",
            "WH" + Date.now(),
            this.props.defaultContactName,
            "WAREHOUSE",
            this.props.defaultEmailAddress,
            this.props.defaultPhoneNumber,
            "IU",
            true,
            true
          )
        );
      }
      if (!types.includes("VENDOR_RESPONSIBLE") && this.props.defaultFacilityType === "VENDOR_RESPONSIBLE"
            && this.props.operationType === "VENDOR_RESPONSIBLE") {
        const thirdPMContactXid = "VR" + Date.now();
        this.setState({ thirdPartyContactXId: thirdPMContactXid });
        this.state.rows.push(
          new AdditionalContactDetails(
            "",
            thirdPMContactXid,
            this.props.defaultContactName,
            "VENDOR_RESPONSIBLE",
            this.props.defaultEmailAddress,
            this.props.defaultPhoneNumber,
            "IU",
            true,
            true
          )
        );
      }
      if (types.includes("VENDOR_RESPONSIBLE") && this.props.defaultFacilityType !== "VENDOR_RESPONSIBLE") {
        const newRow = this.state.rows.filter((row: AdditionalContactDetails) => {
          if (row.contactXid !== this.state.thirdPartyContactXId) {
            return row;
          }
        });
        this.setState({
          rows: newRow,
          defaultValuesLoaded: true,
          showContactDetails: true,
          previousFacilityType: this.props.defaultFacilityType,
        }, () => this.props.updateContactList([...newRow]));
      } else {
        const updatedRows = [...this.state.rows];
        this.setState({
          rows: updatedRows,
          defaultValuesLoaded: true,
          showContactDetails: true,
          previousFacilityType: this.props.defaultFacilityType,
        }, () => this.props.updateContactList([...updatedRows]));
      }
    }
    let list = this.state.rows.map((contact: AdditionalContactDetails) => {
      let hoverText = "";
      if ("RELEASE_SUMMARY" === contact.jobTitle) {
        hoverText =
          "Person that will receive a summary report on order release creation";
      } else if ("TENDER" === contact.jobTitle) {
        hoverText =
          "Person that will receive bill of lading and instructions when shipment is assigned to carrier";
      } else if ("WAREHOUSE" === contact.jobTitle) {
        hoverText =
          "Person that a carrier will contact when scheduling pick up appointments";
      } else if ("VENDOR_RESPONSIBLE" === contact.jobTitle) {
        hoverText =
          "Person that is responsible when scheduling pick up appointments";
      }

      return contact.operation !== "CD" ? (
        <tr key={contact.contactXid}>
          <td>
            <span
              className="form-check form-switch"
              style={{ color: contact.active ? "green" : "gray" }}
            >
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="ActiveStatus"
                id={"activeStatus" + contact.contactXid}
                checked={contact.active}
                onChange={this.handleChange.bind(this, contact.contactXid)}
              />
              {contact.active ? "Active" : "Inactive"}
            </span>
          </td>

          <td className="col-md" style={{ width: "12%" }}>
            <label id={"contactId" + contact.contactXid} className="form-label">
              {contact.contactXid}
            </label>
          </td>

          <td className="col-md" style={{ width: "20%" }}>
            <FlagableTextField
              name="ContactName"
              value={contact.contactName}
              id={"contactName" + contact.contactXid}
              onChange={this.handleChange.bind(this, contact.contactXid)}
              className="form-control"
              variant="outlined"
              disabled={!contact.isDelete}
            />
          </td>

          <td className="col-md" style={{ width: "18%", tableLayout: "fixed" }}>
            <NativeSelect
              id={"contactType" + contact.contactXid}
              className="form-control"
              name="ContactType"
              title={hoverText}
              defaultValue={contact.jobTitle}
              onChange={this.handleChange.bind(this, contact.contactXid)}
              disabled={!contact.isDelete}
            >
              {this.state.operationType==="RELEASE_SUMMARY" && <option
                value="RELEASE_SUMMARY"
                selected={"RELEASE_SUMMARY" === contact.jobTitle}
              >
                RELEASE_SUMMARY
              </option>}
              {this.state.operationType==="TENDER" && <option
                value="TENDER"
                selected={"TENDER" === contact.jobTitle}
              >
                TENDER
              </option>}
              {this.state.operationType==="WAREHOUSE" && <option
                value="WAREHOUSE"
                selected={"WAREHOUSE" === contact.jobTitle}
              >
                WAREHOUSE
              </option>}
              {this.state.operationType==="VENDOR_RESPONSIBLE" && <option
                value="VENDOR_RESPONSIBLE"
                selected={"VENDOR_RESPONSIBLE" === contact.jobTitle}
              >
                VENDOR_RESPONSIBLE
              </option>}
            </NativeSelect>
          </td>

          <td className="col-md">
            <table style={{ width: "100%" }}>
              <tr>
                <td>
                  <FlagableTextField
                    name="EmailAddress"
                    className="form-control"
                    value={contact.emailAddress}
                    id={"emailAddress" + contact.contactXid}
                    onChange={this.handleChange.bind(this, contact.contactXid)}
                    variant="outlined"
                    style={{ width: "100%" }}
                    disabled={!contact.isDelete}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {!isValidEmail(contact.emailAddress) && (
                    <span
                      id="contactEmailError"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      Email is not valid.
                    </span>
                  )}
                </td>
              </tr>
            </table>
          </td>

          <td className="col-md" style={{ width: "12%" }}>
            <table>
              <tr>
                <td>
                  <FlagableTextField
                    name="PhoneNumber"
                    className="form-control"
                    value={contact.phone1}
                    id={"phoneNumber" + contact.contactXid}
                    onChange={this.handleChange.bind(this, contact.contactXid)}
                    variant="outlined"
                    disabled={!contact.isDelete}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {!isValidPhone(contact.phone1) && (
                    <span
                      id="contactPhoneNumberError"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      Phone Number <br />
                      is 10 digits.
                    </span>
                  )}
                </td>
              </tr>
            </table>
          </td>

          {contact.isDelete && 
          <td className="col-md" style={{ width: "7%" }}>
            <button
              type="button"
              id={"deleteRow" + contact.contactXid}
              onClick={this.handleRemoveSpecificRow(contact.contactXid)}
              name="DeleteContact"
              className="btn btn-danger"
            >
              Delete
            </button>
          </td>}
        </tr>
      ) : (
        ""
      );
    });

    return (
      <div className="pageContent-style MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
        <div
          className="MuiCollapse-container MuiCollapse-entered"
          style={{
            height: "auto",
            minHeight: "0px",
            transitionDuration: "327ms",
          }}
        >
          <div className="pageContent-style MuiCollapse-wrapper">
            <div className="MuiCollapse-wrapperInner pageContent-style">
              <div id="pannel1a-content" role="region">
                <div className="MuiAccordionDetails-root">
                  <div>
                    <table className="table" style={{tableLayout: "fixed"}}>
                      <thead>
                        <tr>
                          {this.state.tableHeaders.map(function (
                            headerText: any
                          ) {
                            return (
                              <th>
                                {" "}
                                {headerText}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.showContactDetails
                          ? list
                          : "No data to display "}
                      </tbody>
                    </table>
                    <div>
                      <button
                        type="button"
                        id="addContact"
                        onClick={this.handleAddRow}
                        className="btn btn-primary"
                      >
                        Add Contact
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
